import React from 'react';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';
import moment from 'moment';

import { Select, DatePicker } from 'ui/components';
import { formatDate } from 'utilities/common';

const initialState = {
  week: null,
};

const Filter = ({ show, onClose, StateTable, setCount }) => {
  const [{ week }, setState] = React.useState(initialState);

  const handleFilter = async (e) => {
    if (StateTable?.State?.filter) {
      let x = [];
      Object.keys(StateTable?.State?.filter).forEach((k) => {
        if (StateTable?.State?.filter[k] && k !== 'start_at') {
          x.push(k);
        }
      });
      setCount(x);
    }
  };

  const $handleFilterWeek = async (e) => {
    var sw = '';
    var ew = '';
    if (e) {
      const endWeek = moment(e).endOf('week').toDate();
      sw = formatDate(e, 'YYYY-MM-DD');
      ew = formatDate(endWeek, 'YYYY-MM-DD');
    }

    setState((prevState) => ({ ...prevState, week: e }));

    StateTable?.filter('start_at', sw);
    StateTable?.filter('end_at', ew);
    handleFilter();
  };

  React.useEffect(() => {
    handleFilter();
  }, []);

  React.useEffect(() => {
    var startWeek = moment().startOf('week').add(1, 'day').toDate();
    $handleFilterWeek(startWeek);
  }, []);

  return (
    <>
      <div
        className={cn(
          show
            ? 'col-md-3 d-none d-md-block py-3 px-3 m-0 border-start'
            : 'd-none'
        )}
      >
        <div className="mb-3 border-bottom">
          <div className="d-flex align-items-center justify-content-between">
            <div className="page-pretitle fs-7 text-secondary">Filter</div>
            <div className="mt-n1">
              <button className="btn btn-action-close " onClick={onClose}>
                <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
              </button>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">Minggu ke</div>
          <DatePicker
            selectionMode="week"
            format={`Week - WW`}
            value={week}
            onChange={(date) => {
              $handleFilterWeek(date);
            }}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">Driver</div>
          <Select.Remote
            placeholder=""
            url="/tms/driver"
            initialValue={StateTable?.State?.filter?.driver_id}
            row={(d) => {
              return {
                value: d.id,
                label: d.name,
              };
            }}
            onSelected={(c) => {
              StateTable?.filter('driver_id', c?.id);
              handleFilter();
            }}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">Vendor</div>
          <Select.Remote
            placeholder=""
            url="/partner"
            params={{'type': 'vendor'}}
            initialValue={StateTable?.State?.filter?.vendor_id}
            row={(d) => {
              return {
                value: d.id,
                label: d.name,
              };
            }}
            onSelected={(c) => {
              StateTable?.filter('vendor_id', c?.id);
              handleFilter();
            }}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">Hub</div>
          <Select.Remote
            placeholder=""
            url="/location/hub"
            params={{ type: 'hub', is_active: 1 }}
            initialValue={StateTable?.State?.filter?.hub_id}
            row={(d) => {
              return {
                value: d.id,
                label: d.name,
              };
            }}
            onSelected={(c) => {
              StateTable?.filter('hub_id', c?.id);
              handleFilter();
            }}
          />
        </div>
      </div>

      <>
        <div
          className={cn('filter-overlay', show ? 'd-block d-md-none' : '')}
          onClick={onClose}
        />
        <div
          className={cn(
            'filter-modal d-block d-md-none py-3',
            show ? 'filter-show' : ''
          )}
        >
          <div className="mb-3 border-bottom">
            <div className="d-flex align-items-center justify-content-between">
              <div className="page-pretitle fs-7 text-secondary">Filter</div>
              <div className="mt-n1">
                <button className="btn btn-action-close " onClick={onClose}>
                  <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
                </button>
              </div>
            </div>
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">Provinsi</div>
            <Select.Remote
              placeholder=""
              url="/region/province"
              initialValue={StateTable?.State?.filter?.destination_province_id}
              row={(d) => {
                return { value: d?.province_id, label: d?.province_name };
              }}
              onSelected={(c) => {
                StateTable?.filter('destination_province_id', c?.province_id);
                handleFilter();
              }}
            />
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">Wilayah</div>
            <Select.Remote
              placeholder=""
              url="/region"
              initialValue={StateTable?.State?.filter?.destination_village_id}
              params={{
                search:
                  StateTable?.State?.filter?.destination_village_postalcode,
              }}
              row={(d) => {
                return {
                  value: d.village_id,
                  label: `${d.village_name}, ${d.district_name}, ${d.regency_name}, ${d?.province_name} ${d.postal_code} `,
                };
              }}
              onSelected={(c) => {
                StateTable?.filter('destination_village_id', c?.village_id);
                StateTable?.filter(
                  'destination_village_postalcode',
                  c?.postal_code
                );
                handleFilter();
              }}
            />
          </div>
        </div>
      </>
    </>
  );
};

export default Filter;
